// Chart voting island. The chart display is server-rendered; this drives the rate-chart
// selection (min/max), the "your choices" list, and the reCAPTCHA form submit to the existing
// /umbraco/api/charts/PostSubmitChart endpoint. Mirrors charts.component / chart-form.component.
//
// Registered as an Alpine.data component (used by _SiteCharts via x-data="chartVote({...})").
import { renderRecaptcha, recaptchaToken, resetRecaptcha } from './recaptcha.js';

export function registerChartVote(Alpine) {
  Alpine.data('chartVote', (cfg) => ({
    selected: [],
    maxItems: cfg.maxItems || 0,
    minItems: cfg.minItems || 0,
    isCantVote: !!cfg.isCantVote,
    chartId: cfg.chartId || 0,
    pageId: cfg.pageId || 0,
    showForm: false,
    submitting: false,
    success: false,
    error: '',
    widgetId: null,
    form: { name: '', email: '', phone: '', FreeTextAnswer: '', SecondFreeTextAnswer: '' },

    initCaptcha() {
      renderRecaptcha(this.$refs.captcha, (id) => { this.widgetId = id; });
    },

    isSelected(id) { return this.selected.some(t => t.id === id); },

    // toggle from the rate-track button ($el carries the track's data-* attributes)
    toggle(el) {
      if (this.isCantVote) return;
      const id = parseInt(el.dataset.id, 10);
      const i = this.selected.findIndex(t => t.id === id);
      if (i >= 0) { this.selected.splice(i, 1); return; }
      if (this.maxItems && this.selected.length >= this.maxItems) return;
      this.selected.push({ id, name: el.dataset.name, quoteName: el.dataset.quote, listImage: el.dataset.image });
      if (this.error === 'min' && this.selected.length >= this.minItems) this.error = '';
    },

    remove(track) {
      const i = this.selected.findIndex(t => t.id === track.id);
      if (i >= 0) this.selected.splice(i, 1);
    },

    openForm() {
      if (this.selected.length >= this.minItems) this.showForm = true;
      else this.error = 'min';
    },

    async submit() {
      const token = recaptchaToken(this.widgetId);
      if (!token) { this.error = 'WrongRecaptcha'; return; }
      this.error = '';
      this.submitting = true;
      try {
        const res = await fetch('/umbraco/api/charts/PostSubmitChart', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: this.form.name,
            email: this.form.email,
            phone: this.form.phone,
            chartId: this.chartId,
            chartCurrentId: this.pageId,
            selectedTracks: this.selected.map(t => t.id),
            FreeTextAnswer: this.form.FreeTextAnswer,
            SecondFreeTextAnswer: this.form.SecondFreeTextAnswer,
            RecaptchaResponse: token
          })
        });
        if (res.ok) {
          this.success = true;
        } else {
          const data = await res.json().catch(() => null);
          this.error = data && data.result === 'WrongRecaptcha' ? 'WrongRecaptcha' : 'try';
        }
      } catch (e) {
        console.error('[chartVote] submit failed', e);
        this.error = 'try';
      }
      this.submitting = false;
      resetRecaptcha(this.widgetId);
    }
  }));
}
